import ServerRequestUtil from '../utils/ServerRequestUtil';
import AuthUtil from '../utils/AuthUtil';

export default new class {

    constructor() {
        this.STATUSES = {
            NOT_UPLOADED: '0',
            UPLOADED: '1',
            APPROVED: '2',
            REJECTED: '3',
            RE_UPLOADED: '4',
        };
    }

    uploadKyc(data) {
        let formData = new FormData();
        for(let key in data) {
            if(data.hasOwnProperty(key)){
                formData.append(key, data[key]);
            }
        }
        return ServerRequestUtil.post('/api/app/kyc/upload', formData);
    }

    getStatus() {
        return ServerRequestUtil.get('/api/app/kyc/get');
    }

}
